export const toggleInventory = () => ({
  type: "TOGGLE_INVENTORY"
});

export const setError = (reason: string) => ({
  type: "SET_ERROR",
  reason
});
